module.exports = __webpack_public_path__ + "media/images/recruit/mv/img-mark-04-f624737f8e7e750ed20de9a2224d54a2.svg";